
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientCompanyPaymentPreferencesResource,
  ClientCompanyPaymentPreferencesUpdateRequest,
} from '../models';
import {
    ClientCompanyPaymentPreferencesResourceFromJSON,
    ClientCompanyPaymentPreferencesResourceToJSON,
    ClientCompanyPaymentPreferencesUpdateRequestFromJSON,
    ClientCompanyPaymentPreferencesUpdateRequestToJSON,
} from '../models';

export interface GetCompanyPaymentPreferencesRequest {
    companyId: string;
}

export interface UpdateCompanyPaymentPreferencesRequest {
    companyId: string;
    clientCompanyPaymentPreferencesUpdateRequest: ClientCompanyPaymentPreferencesUpdateRequest;
}

/**
 * 
 */
export class ClientCompanyPaymentPreferencesApi extends runtime.BaseAPI {

    /**
          */
    async getCompanyPaymentPreferencesRaw(requestParameters: GetCompanyPaymentPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyPaymentPreferencesResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompanyPaymentPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientCompanyPaymentPreferencesResource>({
            path: `/client-settings/api/{companyId}/payment-preferences`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyPaymentPreferencesResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCompanyPaymentPreferences(requestParameters: GetCompanyPaymentPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyPaymentPreferencesResource> {
        const response = await this.getCompanyPaymentPreferencesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async updateCompanyPaymentPreferencesRaw(requestParameters: UpdateCompanyPaymentPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyPaymentPreferencesResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateCompanyPaymentPreferences().'
            );
        }

        if (requestParameters['clientCompanyPaymentPreferencesUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyPaymentPreferencesUpdateRequest',
                'Required parameter "clientCompanyPaymentPreferencesUpdateRequest" was null or undefined when calling updateCompanyPaymentPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientCompanyPaymentPreferencesResource>({
            path: `/client-settings/api/{companyId}/payment-preferences`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanyPaymentPreferencesUpdateRequestToJSON(requestParameters['clientCompanyPaymentPreferencesUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyPaymentPreferencesResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async updateCompanyPaymentPreferences(requestParameters: UpdateCompanyPaymentPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyPaymentPreferencesResource> {
        const response = await this.updateCompanyPaymentPreferencesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
